import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Box } from "sprout-ui-primitives";
import styled from "styled-components";
import { visuallyHiddenStyle } from "../utils";
const RadioWrapper = styled(Flex)`
  cursor: ${({ $disabled  })=>$disabled ? "not-allowed" : "pointer"};
`;
const RadioLabel = styled(Flex)`
  user-select: none;
`;
const Radio = (props)=>{
    const { disabled , checked , label , onChange , name , value , appendLabel  } = props;
    return /*#__PURE__*/ _jsxs(RadioWrapper, {
        as: "label",
        alignItems: "center",
        $disabled: !!disabled,
        children: [
            /*#__PURE__*/ _jsx("input", {
                checked: checked,
                disabled: disabled,
                type: "radio",
                style: visuallyHiddenStyle,
                onChange: onChange,
                name: name,
                value: value
            }),
            /*#__PURE__*/ _jsx(Flex, {
                alignItems: "center",
                justifyContent: "center",
                width: "48px",
                height: "48px",
                children: /*#__PURE__*/ _jsx(Flex, {
                    alignItems: "center",
                    justifyContent: "center",
                    width: "24px",
                    height: "24px",
                    color: disabled ? "white.100" : checked ? "white.100" : undefined,
                    borderStyle: "solid",
                    borderWidth: "2px",
                    borderColor: disabled ? "grey.100" : "blue.500",
                    borderRadius: "50%",
                    children: checked && /*#__PURE__*/ _jsx(Box, {
                        width: "12px",
                        height: "12px",
                        bg: disabled ? "grey.100" : "blue.500",
                        borderRadius: "50%"
                    })
                })
            }),
            label && /*#__PURE__*/ _jsx(RadioLabel, {
                as: "span",
                ml: 1,
                fontWeight: "bold",
                color: disabled ? "black.16" : undefined,
                children: label
            }),
            appendLabel
        ]
    });
};
export default Radio;
